<template>
	<h1>节能看板</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>